const initialState = {
    accentColor: null,
    slug: null,
    queueOn: null,
    queueIt: null,
    orgListingId: null,
};

export function orgListingConfig(state = initialState, action) {
    switch (action.type) {
        case 'SET_ORG_LISTING_CONFIG':
            return {
                ...state,
                ...action.val,
            };
        default:
            return state;
    }
}
